import {Row, Col, Carousel, CarouselItem, Icon, Button, Page, Input, Select, Form, FormItem, CheckboxGroup, Checkbox, Cascader, Modal} from 'iview'

const RequiredCom = {
    install: function (Vue) {
        Vue.component('Row', Row)
        Vue.component('Col', Col)
        Vue.component('Carousel', Carousel)
        Vue.component('CarouselItem', CarouselItem)
        Vue.component('Icon', Icon)
        Vue.component('Button', Button)
		Vue.component('Page', Page)
		Vue.component('Input', Input)
		Vue.component('Select', Select)
		Vue.component('Form', Form)
		Vue.component('FormItem', FormItem)
		Vue.component('CheckboxGroup', CheckboxGroup)
		Vue.component('Checkbox', Checkbox)
		Vue.component('Cascader', Cascader)
        Vue.component('Modal', Modal)
    }
}

export default RequiredCom